// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/preset_webhook_templates" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetWebhookTemplates } from "./constants";
import type { EngagementPresetWebhookTemplatesParams, EngagementPresetWebhookTemplatesResult } from "./types";

export const getDataTableEngagementPresetWebhookTemplates = reactQueryFetcherAdapter(
  engagementPresetWebhookTemplates,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementPresetWebhookTemplatesParams
  ): Promise<EngagementPresetWebhookTemplatesResult> => {
    return fetch(
      "/engagement/preset_webhook_templates",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        react_datatable: true,
      },
      { signal }
    );
  }
);
